import { css } from "@emotion/react";

export const summaryContainer = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const itemDetails = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const totalRow = css`
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;
